/* eslint-disable */
define(function (Viewport) {
    /**
     * @title    - Cta Module
     * @desc     - Overall code for Cta module
     * @param    - none
     * @return   - object with public functions and/or variables
     */
    Form = (function () {
        var init = function () {
            if (document.getElementsByClassName('gform_wrapper').length > 0) {
                jQuery(document).ready(function ($) {
                    var zipcode = $("[class*='gf_zipcode'] input")

                    if (zipcode !== undefined) {
                        for (var x = 0; x < zipcode.length; x++) {
                            ;(function () {
                                var count = x

                                var zipcodeInput = zipcode[x],
                                    housenumberInput = $(
                                        '.gf_housenumber-' + (x + 1) + ' input'
                                    ),
                                    housenumberExtraInput = $(
                                        '.gf_housenumber_extra-' +
                                            (x + 1) +
                                            ' input'
                                    )

                                if (
                                    zipcodeInput !== undefined &&
                                    housenumberInput !== undefined
                                ) {
                                    var blurEl = [
                                        zipcodeInput,
                                        housenumberInput,
                                        housenumberExtraInput,
                                    ]

                                    for (var i = 0; i < blurEl.length; i++) {
                                        var input = $(blurEl[i])

                                        function getAddress() {
                                            if (
                                                $(zipcodeInput).val() !== '' &&
                                                $(housenumberInput).val() !== ''
                                            ) {
                                                var postalCodeData = {}
                                                postalCodeData.CheckPostalCodeInputJSON =
                                                    {}

                                                postalCodeData.CheckPostalCodeInputJSON.CheckPostalCode =
                                                    {
                                                        Username: 'Wordpress',
                                                        HouseNumber:
                                                            $(
                                                                housenumberInput
                                                            ).val(),
                                                        HouseNumberAddition: $(
                                                            housenumberExtraInput
                                                        ).val(),
                                                        PostalCode: $(
                                                            zipcodeInput
                                                        )
                                                            .val()
                                                            .replace(/ /g, ''),
                                                        CountryCode: 'NL',
                                                    }

                                                $.ajax({
                                                    type: 'POST',
                                                    url:
                                                        window.__appData__
                                                            .ajaxUrl +
                                                        '?action=reactapi&check=pc&endpoint=' +
                                                        encodeURIComponent(
                                                            'Relatie/CheckPostalCode'
                                                        ) +
                                                        '&security=' +
                                                        window.__appData__
                                                            .nonce,
                                                    data: JSON.stringify(
                                                        postalCodeData
                                                    ),
                                                    contentType:
                                                        'application/json; charset=utf-8',
                                                    dataType: 'json',
                                                    success: function (
                                                        response
                                                    ) {
                                                        var data =
                                                                response
                                                                    .CheckPostalCodeOutputJSON
                                                                    .CheckPostalCode,
                                                            errorMessage = $(
                                                                '.gf_dynamic_address-' +
                                                                    (count +
                                                                        1) +
                                                                    ' .form-group__notification'
                                                            )

                                                        errorMessage.removeClass(
                                                            'gfield_visibility_hidden'
                                                        )

                                                        if (
                                                            data.ReturnStatus
                                                                .Code === 'E'
                                                        ) {
                                                            errorMessage.text(
                                                                'Combinatie niet gevonden'
                                                            )
                                                        } else {
                                                            var address =
                                                                data.ResultAddress

                                                            $(
                                                                '.gf_street-' +
                                                                    (count +
                                                                        1) +
                                                                    ' input'
                                                            ).val(
                                                                address.Street
                                                            )
                                                            $(
                                                                '.gf_city-' +
                                                                    (count +
                                                                        1) +
                                                                    ' input'
                                                            ).val(address.City)

                                                            errorMessage.text(
                                                                address.Street +
                                                                    ' ' +
                                                                    address.HouseNumber +
                                                                    (address.HouseNumberAddition !==
                                                                    undefined
                                                                        ? address.HouseNumberAddition
                                                                        : '') +
                                                                    ', ' +
                                                                    address.PostalCode +
                                                                    ' ' +
                                                                    address.City
                                                            )
                                                        }
                                                    },
                                                })
                                            }
                                        }

                                        input.on('blur', getAddress)

                                        getAddress()
                                    }
                                }
                            })()
                        }
                    }
                })
            }
        }

        // return public functions and/or variables to use in other modules
        return {
            init: init,
        }
    })()

    Form.init()
})



// WEBPACK FOOTER //
// ./scripts/legacy/modules/form.js